// Options Actions
export const FETCH_PATIENT_DEVICE_REQUEST = "FETCH_PATIENT_DEVICE_REQUEST";
export const FETCH_PATIENT_DEVICE_SUCCESS = "FETCH_PATIENT_DEVICE_SUCCESS";
export const FETCH_PATIENT_DEVICE_ERROR = "FETCH_PATIENT_DEVICE_ERROR";
